import {
  idField,
  textField,
  numericField,
  fileInputField,
  textAreaField,
  selectionField,
} from "../../utils/generalUtils";

import { coursesStorage } from "../../storage/storageClasses";

const publicationFieldsConfig = {
  tableTitle: "Publications",
  fields: [
    idField(),
    textAreaField("content", "Content"),
    selectionField("type", "Type", [
      "Journal Paper",
      "Conference Paper",
      "Book",
      "Preprint",
      "Thesis",
      "Book Chapter",
      "Other Publication",
    ]),
    numericField("year", "Year"),
  ],
};

const courseFieldsConfig = {
  tableTitle: "Courses",
  fields: [
    idField(),
    textField("number", "Course Number"),
    textField("section", "Section"),
    textField("title", "Title"),
    textField("semester", "Semester"),
    textField("year", "Year"),
    textField("dept", "Department"),
    textField("link", "Homepage"),
    fileInputField("outline", "Course Outline", coursesStorage),
    textField("description", "Description"),
  ],
};

const currentStudentFieldsConfig = {
  tableTitle: "Current Students",
  fields: [idField(), textAreaField("contents", "Contents")],
};

const educationFieldsConfig = {
  tableTitle: "Education",
  fields: [
    idField(),
    textField("title", "Degree Title"),
    textField("name", "Name of degree"),
    textField("completion_month", "Month"),
    textField("completion_year", "Year"),
    textField("university_name", "University"),
    textField("university_address", "Address"),
    textField("university_city", "City"),
    textField("university_province", "Province"),
    textField("university_postal_code", "Postal Code"),
    textField("university_country", "Country"),
    textField("university_homepage", "Homepage"),
  ],
};

const formerStudentFieldsConfig = {
  tableTitle: "Former Students",
  fields: [idField(), textAreaField("contents", "Contents")],
};

const researchFundingFieldsConfig = {
  tableTitle: "Research Funding",
  fields: [idField(), textAreaField("title", "Content")],
};

const researchInterestFieldsConfig = {
  tableTitle: "Research Interests",
  fields: [idField(), textAreaField("title", "Content")],
};

const awardFieldsConfig = {
  tableTitle: "Awards",
  fields: [
    idField(),
    textField("title", "Title"),
    textField("link", "Link"),
    numericField("year", "Year"),
  ],
};

const editorialAppointmentsFieldsConfig = {
  tableTitle: "Editorial Appointments",
  fields: [idField(), textAreaField("contents", "Contents")],
};

const academicPositionFieldsConfig = {
  tableTitle: "Academic Positions",
  fields: [
    idField(),
    textField("position", "Position Title"),
    textField("start_year", "Start Year"),
    textField("end_year", "End Year"),
    textField("university", "University Name"),
    textField("university_link", "Link to University Homepage"),
    textField("department", "Department"),
    textField("department_link", "Link to Department Homepage"),
  ],
};

export {
  publicationFieldsConfig,
  courseFieldsConfig,
  currentStudentFieldsConfig,
  educationFieldsConfig,
  formerStudentFieldsConfig,
  researchFundingFieldsConfig,
  researchInterestFieldsConfig,
  awardFieldsConfig,
  academicPositionFieldsConfig,
  editorialAppointmentsFieldsConfig,
};
